import RaisedGlyph from './raised-glyph';

export default RaisedGlyph;
